var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import useInterval from 'root/src/client/web/hooks/useInterval';
/**
 * Cron runs around ~22s of minute
 */
const POLLING_INTERVAL = 8000;
export const usePickingWinner = () => {
    const { fetchGiveaways, fetchScheduler } = useCreatorDataApi();
    useInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        void fetchGiveaways();
        void fetchScheduler();
    }), POLLING_INTERVAL);
};
